
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './flags.css';
import { PrimeReactProvider } from 'primereact/api';
import Tailwind from 'primereact/passthrough/tailwind'; // Tailwind passthrough for PrimeReact
// import ThemeSwitcher from './components/ThemeSwitcher';
// Create the root for rendering
const root = ReactDOM.createRoot(document.getElementById('root'));
// Render the application
root.render(
  <React.StrictMode>
    {/* Providing PrimeReact with Tailwind integration */}
    <PrimeReactProvider value={{ unstyled: true, pt: Tailwind }}>
      {/* <ThemeSwitcher /> */}
      <App />
    </PrimeReactProvider>
  </React.StrictMode>
);
